import axios from 'axios'

const API_URL = process.env.VUE_APP_URL_API + '/Users/'

class AuthService {
  login (user) {
    return axios
      .post(API_URL + 'login', {
        email: user.email,
        password: user.password,
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data))
        }

        if (response.data.token) {
          localStorage.setItem('user', JSON.stringify(response.data))
        }

        if (response.data.id) {
          localStorage.setItem('user', JSON.stringify(response.data))
        }

        return response.data
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }

  logout () {
    localStorage.removeItem('user')
  }

  register (user) {
    return axios.post(API_URL, {
      username: user.username,
      email: user.email,
      password: user.password,
    })
  }
}

export default new AuthService()
